<mat-form-field>
  <mat-label>{{  label || 'Select Supplier' }}</mat-label>
  <mat-select #supplierSelect>
    @for (supplier of suppliers; track supplier) {
      <mat-option
        value="{{supplier.supplier_id}}">
        {{ supplier.supplier_name }}
      </mat-option>
    }
  </mat-select>
</mat-form-field>
